import { render, staticRenderFns } from "./ProveedoresCRUD.vue?vue&type=template&id=47fb766f"
import script from "./ProveedoresCRUD.vue?vue&type=script&lang=js"
export * from "./ProveedoresCRUD.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports